<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Strong>Note : If any data is not available or applicable, kindly mention NA </Strong>
    <v-form
      id="canteen_details_form"
      @submit.prevent="submit"
      v-model="isValid"
      v-if="loader"
    >
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input
            type="hidden"
            :value="application_form_data.admission_form_id"
            name="admission_form_id"
          /> </v-col
      ></v-row>
      <v-row dense justify="center" v-if="is_canteen_facility_needed != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="is_canteen_facility_needed.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="is_canteen_facility_needed.field_value"
            :items="is_canteen_facility_needed.options"
            :name="is_canteen_facility_needed.field_name"
            :required="is_canteen_facility_needed.required"
            :rules="
              is_canteen_facility_needed.required
                ? [
                    v =>
                      !!v ||
                      is_canteen_facility_needed.field_display_name +
                        ' is required'
                  ]
                : []
            "
            :clearable="is_canteen_facility_needed.required ? false : true"
            :hint= is_canteen_facility_needed.field_display_name
            persistent-hint
            single-line
            prepend-icon="mdi-account-question"
            outlined
          ></v-autocomplete> </v-col
      ></v-row>
   

        <!-- <v-row dense justify="center" v-if="guidelines.length && is_canteen_facility_needed.field_value === 'Yes'">
                    <v-card outlined class="pa-4" style="max-width: 800px;">
                        <v-card-title class="text-h6 font-weight-bold">General Rules and Regulations for Transport</v-card-title>
                        <v-card-text>
                        <v-list dense>
                            <v-list-item v-for="(guideline, index) in guidelines" :key="index">
                            <v-list-item-content>
                                <v-list-item-title v-html="guideline"></v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        </v-card-text>
                    </v-card>
        </v-row> -->
        <br />
        <v-row dense justify="center" v-if="defaultValues!='' && is_canteen_facility_needed.field_value == 'Yes'">
          <span v-html="defaultValues"></span>
        </v-row>

        <v-row
        dense
        justify="center"
        v-if="is_canteen_facility_needed.field_value == 'Yes'"
      >
        <v-col cols="10" sm="10" md="10">
          <v-checkbox
            v-model="canteen_declaration.field_value"
            :name=canteen_declaration.field_name
            :value=canteen_declaration.field_value
            color="primary darken-1"
            label="I hereby verify that I have read, understood and accepted the statements above"
            :rules="
              canteen_declaration.required
                ? [
                    v =>
                      !!v ||
                      canteen_declaration.field_display_name +
                        ' is required'
                  ]
                : []
            "
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row justify="center" dense v-if="is_canteen_facility_needed.field_value == 'Yes'">
        <v-col cols="10" sm="10" md="10">
          <div style="text-align:center">
            <v-btn
              class="mt-2"
              :color="isValid ? 'primary darken-1' : 'grey lighten-1'"
              @click="submit"
              :disabled="!canteen_declaration.field_value"
              >Save</v-btn
            >
          </div>
        </v-col></v-row
      >
      <v-row justify="center" dense v-if="is_canteen_facility_needed.field_value == 'No'">
        <v-col cols="10" sm="10" md="10">
          <div style="text-align:center">
            <v-btn
              class="mt-2"
              :color="isValid ? 'primary darken-1' : 'grey lighten-1'"
              @click="submit"
              :disabled="!isValid"
              >Save</v-btn
            >
          </div>
        </v-col></v-row
      >
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      isValid: true,
      loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      application_form_data: {
        admission_form_no: "",
        admission_form_id: "",
        display_admission_form_no: ""
      },
      is_canteen_facility_needed: {},
      canteen_declaration: {},
      defaultValues:{},
      guidelines: [
        "The Transport Form or the online ERP request is to be submitted for enrolment and availing of bus services.",
        "The school transport facility cannot be claimed as a right.",
        "The travel time to reach the pick-up/drop point is approximately <strong>55 minutes</strong>.",
        "Transport fee will be charged for <strong>12 months</strong> during the given academic year.",
        "Transport fee once paid <strong>will not be refunded or adjusted</strong> under any circumstances.",
        "Bus fee will be charged on a term basis for <strong>both ways (to and fro)</strong>, even if the facility has been/ is being availed for part of that term.",
        "Transport will be provided during regular school timings and on school working days only.",
        "Request to discontinue/change routes needs to be intimated to the administrative officer in writing at least two months in advance, or two months' bus fare needs to be paid in lieu of that.",
        "Parents/guardians are not allowed to accompany their wards in the school bus.",
        "The school will not be able to run the bus or compensate the travel days in case of certain emergencies such as: sudden breakdown of the vehicle, sudden sickness of the driver, sudden holidays declared by the government, or any other unavoidable incidents.",
        "GPS has been installed in all the school buses.",
        "Temporary change in routes (drop and/or pick up) for a few days shall not be allowed under any circumstances.",
        "No student shall be allowed to avail the school transport for one way only. In such cases, parents will have to pay fees for both ways (to and fro).",
        "Parents are responsible for ensuring they are present at the bus stop 5 minutes before the specified time. Bus drivers will not wait beyond the specified time for pick-ups.",
        "Buses will not enter inside any society (door-to-door services will not be available).",
        "The transport facility can be withdrawn if the student availing the transport exhibits any kind of indiscipline.",
        "Manhandling of school staff or transport personnel by parents/guardians will result in immediate withdrawal of transport facilities and legal action.",
        "The school transport department shall not be responsible for any loss of students' belongings.",
        "Only authorized students are permitted to travel in the school's transport vehicle.",
        "Any student leaving the school early/late must be picked up by a parent/guardian after informing the class teacher/admin officer/transport in-charge.",
        "Decisions about transport are managed solely by the school administration or transport in-charge."
      ],
    };
  },
  methods: {
    checkdeclarations(){
        if(this.is_canteen_facility_needed.field_value == 'Yes' && !this.canteen_declaration){
            this.isValid=false
        }
        else if(this.is_canteen_facility_needed.field_value == 'Yes' && this.canteen_declaration){
            this.isValid=true
        }
        else if(this.is_canteen_facility_needed.field_value == 'No'){
                this.isValid=true
        }
    },
    submit: function(e) {
      this.loader = false;
      var form = document.getElementById("canteen_details_form");
      var formData = new FormData(form);
      //formData.append("transport_declaration",this.transport_declaration)
      axios.post("/admissionForm/saveCanteenDetails", formData)
      .then(
        response => {
          if (response.data.form_saved == "YES") {
            this.loader = true;
            this.showSnackbar(
              "#4caf50",
              'Saved Successfully...Click on Next Tab To Continue'
            ); // show snackbar on success
          }
          else{
            this.loader = true;
            this.showSnackbar(
              "red",
              response.data.snackbar
            ); // show snackbar on success
            return
          }
          this.$store.commit("setform_progress", response.data.form_progress);
        },
        response => {
          // error callback
        }
      )
      .catch((error) =>{
        console.log(error)
        this.loader = true;
            this.showSnackbar(
              "red",
              'something went wrong!!!'
            ); // show snackbar on success
      });
    },
    getform() {
      axios
        .post("/admissionForm/canteenDetails", this.application_form_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.loader = true;
            this.is_canteen_facility_needed = res.data.is_canteen_facility_needed;
            this.canteen_declaration = res.data.canteen_declaration;
            this.defaultValues = res.data.defaultValues;
            this.$store.commit("setform_progress", res.data.form_progress);
            //this.form_progress = res.data.form_progress
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    }
  },
  mounted() {
    this.application_form_data = this.$store.getters.application_form_data;
    this.getform();
  },
  watch: {
    date(val) {
      this.date_of_birth.field_value = this.formatDate(this.date);
    }
  },
  
};
</script>
